<template lang="pug">
  .standalone-heading(:class="{ 'text-center': textAlignment === 'center' }")
    component.spaced(v-if="heading" :is="headingTag" :class="classes.heading") {{ heading }}
    component(v-if="subHeading" :is="subHeadingTag" :class="classes.subHeading") {{ subHeading }}
</template>

<script>
import { get } from '@/helpers';

export default {
    name: 'Heading',
    props: {
        section: {
            type: Object,
            required: true
        },
        headingTag: {
            type: String,
            default: 'h2'
        },
        headingClass: {
            type: String,
            default: 'is-size-1-desktop is-size-2-tablet is-size-3-mobile font-light'
        },
        subHeadingTag: {
            type: String,
            default: 'h3'
        },
        subHeadingClass: {
            type: String,
            default: 'is-size-5-desktop is-size-6-touch uppercase is-primary'
        }
    },
    computed: {
        heading() {
            return get(this.section, 'contents.0.title');
        },
        subHeading() {
            return get(this.section, 'contents.0.sub_title');
        },
        textAlignment() {
            let alignment = 'center';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'text_alignment');
                if (setting && setting.value !== undefined) alignment = setting.value;
            }

            return alignment;
        },
        classes() {
            let classes = {
                heading: this.headingClass,
                subHeading: this.subHeadingClass
            };

            const settings = get(this.section.contents[0], 'settings') || [];
            const titleSize = settings.find(setting => setting.key === 'title_size');
            const subTitleSize = settings.find(setting => setting.key === 'sub_title_size');

            if (titleSize && titleSize.value !== undefined) {
                switch (titleSize.value) {
                    case 'large':
                        classes.heading = 'is-size-2-desktop is-size-2-tablet is-size-3-mobile';
                        break;

                    case 'small':
                        classes.heading = 'is-size-5-desktop is-size-5-tablet is-size-6-mobile';
                        break;

                    case 'regular':
                    default:
                        classes.heading = 'is-size-4-desktop is-size-4-tablet is-size-5-mobile';
                }
            }

            if (subTitleSize && subTitleSize.value !== undefined) {
                switch (subTitleSize.value) {
                    case 'large':
                        classes.subHeading = 'is-size-4-desktop is-size-5-touch uppercase is-primary';
                        break;

                    case 'small':
                        classes.subHeading = 'is-size-7-desktop is-size-7-touch uppercase is-primary';
                        break;

                    case 'regular':
                    default:
                        classes.subHeading = 'is-size-6-desktop is-size-7-touch uppercase is-primary';
                }
            }

            return classes;
        }
    }
};
</script>

<style lang="sass" scoped>
.standalone-heading
  .is-primary
    color: var(--color-primary)
</style>
